export default __webpack_public_path__ + "static/media/Metal-Cleaners.f54d6e83.png";